import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateBankHolidayInput, UpdateBankHolidayInput } from "../API";
import { ApiActions, gqlMutation, toAWSDate } from ".";

export const useBankHolidayLib = () => {
  const queryClient = useQueryClient();

  const options = {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listBankHolidays"] });
    },
  };

  const { mutateAsync: createBankHoliday } = useMutation({
    ...gqlMutation({ req: "createBankHoliday" }),
    ...options,
  });
  const { mutateAsync: updateBankHoliday } = useMutation({
    ...gqlMutation({ req: "updateBankHoliday" }),
    ...options,
  });
  const { mutateAsync: deleteBankHoliday } = useMutation({
    ...gqlMutation({ req: "deleteBankHoliday" }),
    ...options,
  });

  const createBankHolidayRecord = async (
    input: CreateBankHolidayInput,
    actions: ApiActions
  ) => {
    const awsDate = toAWSDate(new Date(input.date ?? ""));
    if (!awsDate) return;

    createBankHoliday(
      {
        input: {
          ...input,
          date: awsDate,
        },
      },
      actions
    );
  };

  const updateBankHolidayRecord = async (
    input: UpdateBankHolidayInput,
    actions: ApiActions
  ) => {
    const awsDate = toAWSDate(new Date(input.date ?? ""));
    if (!awsDate) return;

    updateBankHoliday(
      {
        input: {
          ...input,
          date: awsDate,
        },
      },
      actions
    );
  };

  const deleteBankHolidayRecord = async (id: string, actions: ApiActions) => {
    deleteBankHoliday({ input: { id } }, actions);
  };

  return {
    createBankHolidayRecord,
    updateBankHolidayRecord,
    deleteBankHolidayRecord,
  };
};
